import { useMemo } from 'react'
import { Pressable, View } from 'react-native'
import { Icon } from '~/components/icon'
import type { IProductHeaderReviewCompactProps } from '~/index'
import { truncate } from '../../utils/truncate'
import * as C from './product-header-product-review-compact.styles'

const FULL_RATING = 5

export function ProductHeaderReviewCompact({
  quantity,
  rating,
  testID,
  ...pressableProps
}: IProductHeaderReviewCompactProps) {
  const renderStar = useMemo(() => {
    const maxRating = rating <= FULL_RATING ? rating : FULL_RATING

    const intRating = Math.floor(maxRating)
    const rest = FULL_RATING - maxRating
    const emptyStars = Math.floor(rest)
    const hasHalfStar = maxRating - intRating >= 0.5

    const filledStars = Array.from({ length: intRating }, (_, i) => i + 1)
    const outlineStars = Array.from({ length: emptyStars }, (_, i) => i + 1)

    return (
      <View style={{ flexDirection: 'row' }}>
        {filledStars.map(key => (
          <Icon
            key={key}
            symbol="rdicon-star-filled"
            color="colorTextEvaluateDefault"
            size="tiny"
          />
        ))}
        {maxRating < 5 &&
          (hasHalfStar ? (
            <Icon
              symbol="rdicon-star-half"
              color="colorTextEvaluateDefault"
              size="tiny"
            />
          ) : (
            <Icon
              symbol="rdicon-star-outline"
              color="colorTextEvaluateDefault"
              size="tiny"
            />
          ))}
        {outlineStars.map(key => (
          <Icon
            key={key}
            symbol="rdicon-star-outline"
            color="colorTextEvaluateDefault"
            size="tiny"
          />
        ))}
      </View>
    )
  }, [rating])

  return (
    <C.ReviewCompact testID={testID}>
      {renderStar}
      <C.ReviewCompactTextValue>
        {rating <= FULL_RATING ? rating : FULL_RATING}
      </C.ReviewCompactTextValue>
      <Pressable {...pressableProps}>
        <C.ReviewCompactTextReviews>
          {truncate(`(${quantity}) avaliações`)}
        </C.ReviewCompactTextReviews>
      </Pressable>
    </C.ReviewCompact>
  )
}
